import * as React from 'react'
import { Text } from '@metrisk/react_metrisk-components'
import { faLock } from '@fortawesome/free-solid-svg-icons'

import Icon from '@components/Icon/FontAwesomeIcon'
import { DefaultInputs, GBInputs } from './countryInputs'

import './BankDetails.scss'

const BankDetails: React.FunctionComponent<BankDetails.IProps> = (props) => {
  const { value, country, onChange } = props

  const renderInputs = (): JSX.Element => {
    switch (country) {
      case 'GB':
        return <GBInputs value={value} onChange={onChange} />
      default:
        return <DefaultInputs value={value} onChange={onChange} />
    }
  }

  return (
    <div className="bank-details">
      <span className="bank-details__lock">
        <Icon icon={faLock} />
      </span>
      <Text type={'Delta'}>Bank Details</Text>
      <Text type={'P'}>
        If your claim is successful payment will be made by bank transfer with the bank details you supply, please enter
        them below and review them carefully.
      </Text>
      <Text type={'P'}>We will only hold onto your bank details until your claim is fully resolved.</Text>
      <Text type={'P'}>Payments can only be made to the claimant.</Text>
      {renderInputs()}
    </div>
  )
}

export default BankDetails
